export const pestIdentifierPreviewQuery = `
    {
      "allPestIdentifiers": {
        "nodes": *[_type == "pestIdentifier" && slug.current != null]
      }
    }
  `;
